import BlockScroller from "../BlockScroller";
import BlockHead from "../_BlockHead";
import ErrorBlock from "../ErrorBlock";
import { observer } from "mobx-react";
import { UserAvatar } from "../../../utilities/UserAvatar";
import { blockObjectFactory } from "../blockObjectFactory";
import { IBlockComponentProps } from "../_Block";
import { isJson } from "../../../admin/spinup/utilities";
import { getBoolean } from "../../../../utils/DataUtilities";
import { useStores } from "../../../../stores/useStores";
import { useRef } from "react";

interface IStaffBlockProps extends IBlockComponentProps {
  blockObj: IStaffBlockObj;
}

const StaffBlock = observer((props: IStaffBlockProps) => {
  try {
    const { modalStore } = useStores();
    const { blockObj } = props;
    const personBlocksRef = useRef<Map<string, any>>(new Map());

    let json_data = props.blockObj.blockModel.json_data;
    if (typeof json_data === "string" && isJson(json_data))
      json_data = JSON.parse(json_data);

    const displayStaffTitles = getBoolean(
      json_data.block.settings.displayStaffTitles,
    );

    return (
      <BlockScroller
        className="sb-staff-block"
        blockRef={props.blockRef}
        blockObj={props.blockObj}
        setShowExpandButton={props.setShowExpandButton}
        outsideGrid={props.outsideGrid}
      >
        <BlockHead
          blockType={props.blockObj.blockType}
          editableTitle={blockObj.blockModel.title}
          blockId={props.blockObj.id}
        />
        <div className="sb-blockContent">
          <ul className="staff-members">
            {blockObj?.staffMembers.map((staff) => {
              let personBlockObj = personBlocksRef.current.get(staff.id);
              if (!personBlockObj) {
                personBlockObj = blockObjectFactory("person", {
                  id: staff.id,
                  blockModel: staff,
                } as IPersonBlock);
                personBlocksRef.current.set(staff.id, personBlockObj);
              }

              const modalObj = {
                id: staff.id,
                type: "schoolBlocksPerson",
                blockObj: personBlockObj,
              };

              const name = `${staff.fname} ${staff.lname}`;

              return (
                <li key={staff.id} className="row" title={name}>
                  <button onClick={() => modalStore.addModal(modalObj)}>
                    <div
                      className="col-xs-3"
                      style={{ paddingRight: 0, marginRight: 0 }}
                    >
                      <UserAvatar
                        avatarUrl={personBlockObj.blockModel.avatarUrl}
                        fname={staff.fname}
                        lname={staff.lname}
                        size="3"
                      />
                    </div>
                    {staff.title && displayStaffTitles ? (
                      <div className="col-xs-9 sb-staff-name-with-title">
                        <span className={"notranslate"}>{name}</span>
                        <br />
                        <span className="sb-staff-title">{staff.title}</span>
                      </div>
                    ) : (
                      <div className="col-xs-9 sb-staff-name-without-title notranslate">
                        <span>{name}</span>
                      </div>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </BlockScroller>
    );
  } catch (error) {
    return <ErrorBlock blockObj={{ errorMessage: error }} />;
  }
});

export default StaffBlock;
